<template>
  <div class="news">
    <NewsContainer
      :show-municipality-selection="showMunicipalitySelection"
      :selected-municipality-id="municipalityId"
      :excluded-news-item-id="excludedNewsItemId"
      :news-api-url="newsApiUrl"
      :municipality-api-url="municipalityApiUrl"
    />
  </div>
</template>

<script>
import { NewsContainer } from '@jdi-clients/cb-components'

export default {
  components: {
    NewsContainer
  },
  computed: {
    excludedNewsItemId() {
      return this.$root.$data.excludedNewsItemId
    },
    municipalityId() {
      return this.$root.$data.municipalityId
    },
    showMunicipalitySelection() {
      return this.$root.$data.showMunicipalitySelection
    },
    municipalityApiUrl() {
      return this.$root.$data.municipalityApiUrl
    },
    newsApiUrl() {
      return this.$root.$data.newsApiUrl
    }
  }
}
</script>
